import { Radio, Row, Col, Card, Typography } from 'antd';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './AvailabilityQuestionCard.module.scss';
import { AvailabilityDetails } from '../constants/availabilityconstants';

const AvailabilityQuestionCard = (props) => {
  const options = AvailabilityDetails.filter(t => t.user_selectable).map((item, index) => (
    <Card className={classnames(styles.availabilityCard, {[styles.active]:item.value===props.value})} key={index}>
      <Radio value={item.value}>
        <Row type="flex" align="middle">
          <Col>
            <Row type="flex" align="middle" className="pretest-option-title-row">
              <Col className="pretest-option-card-icon"><item.svgIcon width="26px" className={classnames(styles.icon, {[styles.iconActive]: item.value===props.value})} height="24px" alt="Icon" /></Col>
              <Col><Typography.Text className={classnames({[styles.active]:item.value===props.value}, styles.radioTitle)}>{item.label}</Typography.Text></Col>
            </Row>
            <div className="pretest-availability-option-detail"><Typography.Text className="pretest-eng-pro-detail">{item.details}</Typography.Text></div></Col>
        </Row>
      </Radio>
    </Card>
  ));
  return (
    <Radio.Group className={styles.radioGroup} onChange={(e) => props.handleChange(e.target.value)} value={props.value}>{options}</Radio.Group>
  );
};

AvailabilityQuestionCard.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.number
};

export default AvailabilityQuestionCard;
